import EditPriceAndBeneficiaryModal from './EditPriceAndBeneficiaryModal.container'

export default EditPriceAndBeneficiaryModal
